export const formatCrumbName = (name: string, escapeCaseFormatting = false) =>
  escapeCaseFormatting
    ? name
    : name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
